import { useEffect } from "react";

const Preload = () => {
  useEffect(() => {
    const preloader = document.getElementById("preloader");
    if (preloader) {
      preloader.style.display = "none";
    }
    const mainWrapper = document.getElementById("main-wrapper");
    if (mainWrapper) {
      mainWrapper.classList.add("show");
    }
  }, []);

  return (
    <div id="preloader">
      <div className="sk-three-bounce">
        <div className="sk-child sk-bounce1"></div>
        <div className="sk-child sk-bounce2"></div>
        <div className="sk-child sk-bounce3"></div>
      </div>
    </div>
  );
};

export default Preload;
